import React, { useEffect } from 'react';

const Footer = () => {
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearElement = document.getElementById('current-year');
    if (yearElement) {
      yearElement.textContent = currentYear;
    }
  }, []);

  return (
    <footer className="footer-area primary-bg">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="footer-content d-flex flex-wrap justify-content-center justify-content-md-between align-items-center py-4">
              <div className="copyright">&copy; <span id="current-year"></span>, All Rights Reserved By Franklin </div>
              <div id="scroll-to-top" className="scroll-to-top mt-3 mt-sm-0">
                <a href="#top" className="smooth-anchor text-decoration-none">Scroll to Top</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;